<ion-app>
    <div *ngIf="noInternet" class="no-internet">
        <div>
            <ion-icon class="icon haleo-internet-connection"></ion-icon>
            <h2 class="content-title">{{'noInternet' | translate}}</h2>
        </div>
    </div>
    <ion-router-outlet [class.margin-top]="noInternet"></ion-router-outlet>
</ion-app>
